import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['container', 'input', 'confirmButton'];
  static values = {
    confirmWord: { type: String, default: '' }
  };

  connect() {
    this.boundOnConfirmClick = this.onConfirmClick.bind(this);
    const submitEl = this.confirmSubmitElement;
    if (submitEl) {
      submitEl.addEventListener('click', this.boundOnConfirmClick, true);
    }
  }

  disconnect() {
    const submitEl = this.confirmSubmitElement;
    if (submitEl) {
      submitEl.removeEventListener('click', this.boundOnConfirmClick, true);
    }
  }

  // Normal form submit never fires when the confirm button is clicked (e.g. intercepted by Turbo).
  // Use capture-phase click + form.submit() to force a full-page POST.
  onConfirmClick(e) {
    const submitEl = this.confirmSubmitElement;
    const form = this.getFormElement();
    if (!submitEl || submitEl.disabled || !form) return;
    submitEl.disabled = true;
    e.preventDefault();
    e.stopPropagation();
    form.submit();
  }

  getFormElement() {
    if (!this.hasConfirmButtonTarget) return null;
    const t = this.confirmButtonTarget;
    return t.tagName === 'FORM' ? t : (t.form || null);
  }

  // When using button_to, the confirm target can be the form; resolve to the actual submit button
  get confirmSubmitElement() {
    if (!this.hasConfirmButtonTarget) return null;
    const t = this.confirmButtonTarget;
    if (t.tagName === 'FORM') {
      return t.querySelector('button[type=submit], input[type=submit]');
    }
    return t;
  }

  open(e) {
    e.preventDefault();

    if (this.hasContainerTarget) {
      this.containerTarget.classList.remove('hidden');
    }
    if (this.hasInputTarget) {
      this.inputTarget.value = '';
      this.inputTarget.focus();
    }
    const submitEl = this.confirmSubmitElement;
    if (submitEl) {
      submitEl.disabled = true;
    }
  }

  close(e) {
    if (e) {
      e.preventDefault();
    }

    if (this.hasContainerTarget) {
      this.containerTarget.classList.add('hidden');
    }
    if (this.hasInputTarget) {
      this.inputTarget.value = '';
    }
    const submitEl = this.confirmSubmitElement;
    if (submitEl) {
      submitEl.disabled = true;
    }
  }

  check() {
    if (!this.hasInputTarget || !this.hasConfirmButtonTarget) return;

    const trimmed = this.inputTarget.value.trim();
    const matches = trimmed === this.confirmWordValue;

    const submitEl = this.confirmSubmitElement;
    if (submitEl) {
      submitEl.disabled = !matches;
    }
  }

  closeWithKeyboard(e) {
    if (e.key === 'Escape' && this.hasContainerTarget && !this.containerTarget.classList.contains('hidden')) {
      this.close(e);
    }
  }

  closeBackground(e) {
    if (this.hasContainerTarget && e.target === this.containerTarget) {
      this.close(e);
    }
  }
}
